import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { MyApp } from './app.component';

import { AboutPage } from '../pages/about/about';
import { SettingPage } from '../pages/setting/setting';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';

import { WelcomePage } from '../pages/welcome/welcome';
import { LoginPage } from "../pages/login/login";
import { RegisterPage } from "../pages/register/register";

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpModule } from '@angular/http';

import { HttpClientModule } from "@angular/common/http";
import { DataProvider } from '../providers/data/data';
import { UtilProvider } from '../providers/util/util';

import { DetailPage } from "../pages/detail/detail";
import { EntryPage } from "../pages/entry/entry";
import { AdminPage } from "../pages/admin/admin";
import { DaterPage } from "../pages/dater/dater";

@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    SettingPage,
    HomePage,
    TabsPage,
    WelcomePage,
    LoginPage,
    RegisterPage,
    DetailPage,
    EntryPage,
    AdminPage,
    DaterPage
  ],
  imports: [
    BrowserModule, HttpModule, HttpClientModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    SettingPage,
    HomePage,
    TabsPage,
    WelcomePage,
    LoginPage,
    RegisterPage,
    DetailPage,
    EntryPage,
    AdminPage,
    DaterPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    HttpModule,
    HttpClientModule,
    DataProvider,
    UtilProvider
  ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts